import { watch } from "vue";
import { useOverheadStore } from "@/stores/new/overhead.store";
import { PricingService } from "../services/pricing.service";

export const useEstimateInfo = () => {
    const pricingService = new PricingService();
    const overheadStore = useOverheadStore();

    // update overheads sum from estimate
    watch(
        () => overheadStore.activeOveheadItems,
        (activeOveheadItems) => {
            if (activeOveheadItems.length > 0) {
                const sum = pricingService.calculateOverheadTotalPrice();
                overheadStore.activeOverhead?.update({
                    sum,
                });
            }
        },
        { deep: true, immediate: true },
    );
};
